import type { BusinessProfile, PageInfo } from '@@partner:types:app'
import type {
  CommonPager,
  NestedFilter,
  CommonSort
} from '@@partner:types:graphql'

import { gql, useLazyQuery, useQuery } from '@apollo/client'

import {
  SHORTCUT_PAGE_INFO_FIELDS,
  SHORTCUT_BUSINESS_PROFILES_FIELDS
} from '@@partner:graphql/shortcuts'

export interface AllBusinessProfilesQuery {
  allBusinessProfiles: {
    edges: BusinessProfile[]
    pageInfo: PageInfo
  }
}
export interface AllBusinessProfilesQueryVariables {
  filter?: NestedFilter
  sort?: CommonSort
  pager: CommonPager
}

export const GQL_QUERY_ALL_BUSINESS_PROFILES = gql`
  query (
    $filter: NestedFilterInput
    $pager: CommonPagerInput
    $sort: CommonSortInput
  ) {
    allBusinessProfiles(
      filter: $filter
      sort: $sort
      pager: $pager
    ) {
      edges {
        ${SHORTCUT_BUSINESS_PROFILES_FIELDS}
      }
      pageInfo {
        ${SHORTCUT_PAGE_INFO_FIELDS}
      }
    }
  }
`

export const useFetchAllBusinessProfiles = (variables: AllBusinessProfilesQueryVariables) =>
  useQuery<AllBusinessProfilesQuery, AllBusinessProfilesQueryVariables>(
    GQL_QUERY_ALL_BUSINESS_PROFILES,
    {
      variables,
      fetchPolicy: 'cache-and-network'
    }
  )

export const useLazyFetchAllBusinessProfiles = (variables?: AllBusinessProfilesQueryVariables) => 
  useLazyQuery<AllBusinessProfilesQuery, AllBusinessProfilesQueryVariables>(GQL_QUERY_ALL_BUSINESS_PROFILES, {
    variables
  })